import { createReducer, on } from '@ngrx/store';
import * as TaxJurisdictionRateActions from './tax-jurisdiction-rate.actions';
import { TaxJurisdictionRate } from 'src/app/pages/orders/interfaces/tax-jurisdiction-rate.interface';

export interface TaxJurisdictionRateState {
  response: TaxJurisdictionRate | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: TaxJurisdictionRate };
}

export const initialState: TaxJurisdictionRateState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const taxJurisdictionRateReducer = createReducer(
  initialState,
  on(TaxJurisdictionRateActions.checkTaxJurisdictionRate, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TaxJurisdictionRateActions.checkTaxJurisdictionRateSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(TaxJurisdictionRateActions.checkTaxJurisdictionRateFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TaxJurisdictionRateActions.checkTaxJurisdictionRateSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
